import Vue from "vue";
import Vuex from "vuex";

import authentication from "./authentication.js";
import notify from "./notify.js";
import region from "./region";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: [
    authentication,
    notify,
    region
  ],
  strict: process.env.NODE_ENV !== "production"
});



// WEBPACK FOOTER //
// ./src/store/store.js